var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "allocation-con" },
    [
      _c("StepsHeader", { attrs: { activeStep: _vm.activeStep } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "step-con" },
        [
          _vm.activeStep === 1
            ? _c("Step1", {
                attrs: {
                  orderData: _vm.sortedAllocationItemsById,
                  onNext: _vm.firstStepNextClick
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeStep === 2
            ? _c("Step2", {
                attrs: {
                  onNext: _vm.secondStepNextClick,
                  onBack: function() {
                    return _vm.goToStep(1)
                  },
                  onCancel: _vm.stepCancelClick
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeStep === 3
            ? _c("Step3", {
                attrs: {
                  addresses: _vm.allocationData.addresses,
                  onNext: _vm.thirdStepNextClick,
                  onBack: function() {
                    return _vm.goToStep(2)
                  },
                  onCancel: _vm.stepCancelClick
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeStep === 4
            ? _c("Step4", {
                attrs: {
                  onNext: _vm.fourthStepNextClick,
                  onBack: function() {
                    return _vm.goToStep(3)
                  },
                  onCancel: _vm.stepCancelClick
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeStep === 5
            ? _c("Step5", {
                attrs: {
                  orderData: _vm.sortedAllocationItemsById,
                  onNext: _vm.fifthStepNextClick,
                  onBack: function() {
                    return _vm.goToStep(4)
                  },
                  onCancel: _vm.stepCancelClick
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.localStorageData && _vm.localStorageData.length > 0
        ? _c("LocalAllocationOrders", {
            attrs: {
              lineItems: _vm.allocationData.lineItems,
              localOrdersData: _vm.localStorageData,
              onFinishAllocated: _vm.finishAllocated,
              onDeleteItem: _vm.deleteLocalItem,
              onUpdateItem: _vm.updateLocalItem,
              errorArray: _vm.errorArray
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AllocatedOrders", {
        attrs: { ordersData: _vm.allocationData.allocations }
      }),
      _vm._v(" "),
      _vm.popupVisible
        ? _c("UpdateLocalItemPopup", {
            attrs: {
              onSave: _vm.onSave,
              onCancel: _vm.onCancel,
              items: _vm.sortedAllocationItemsById,
              currentAllocatedData: _vm.currentAllocatedData
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFinishAllocationPopup
        ? _c("FinishAllocationPopup", {
            attrs: {
              onContinueClick: _vm.onContinueFinishAllocationPopup,
              onClose: _vm.closeFinishAllocationPopup
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }